import React from 'react';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { Icon, Label, Left, Menu, Right } from './styles';
import SVGIcon from '../../../assets/images/svg/SVGIcon';
import { MenuItemProps } from '../../../interfaces/navbarInterface';
import { ICON_SIZE } from '../../../global/constants';

export const MenuItem = observer(function MenuItem({ path, iconName, label, count, isActive }: MenuItemProps) {
  //Other variable
  const history = useHistory();

  return (
    <Menu
      role='button'
      tabIndex={0}
      onClick={() => {
        if (path) history.push(path);
      }}
      isActive={isActive}
      className={isActive ? 'active-navbar-item-menu ' : 'navbar-menu-name'}>
      <Left isActive={isActive}>
        <Icon>
          <SVGIcon
            name={iconName}
            width={ICON_SIZE.LG}
            height={ICON_SIZE.LG}
            viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
            fill='var(--text-primary)'
          />
        </Icon>
        <Label>{label}</Label>
      </Left>
      {count && count > 0 ? <Right className='count-number'>{count}</Right> : <></>}
    </Menu>
  );
});
